var _defs, _path, _path2, _polygon, _path3, _path4, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenShareOn2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.32 36.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f29f39;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "screen-share-on2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.6,11a3,3,0,0,0-3-3H8.47a3,3,0,0,0-3,3V24.75H33.6ZM18.28,16.44a1.38,1.38,0,0,1,0,1.38l-.34.59,3.35,1.67h0a.69.69,0,0,1,.6-.35h.93a.69.69,0,0,1,.6.35l.47.81a.69.69,0,0,1,0,.69l-.47.81a.69.69,0,0,1-.6.35h-.93a.69.69,0,0,1-.6-.35l-.47-.81a.69.69,0,0,1,0-.69l.11-.19L17.6,19l-.1.18a1.38,1.38,0,0,1-1.2.69H14.71a1.39,1.39,0,0,1-1.2-.69l-.79-1.37a1.38,1.38,0,0,1,0-1.38l.82-1.37a1.38,1.38,0,0,1,1.2-.69h1.58a1.38,1.38,0,0,1,1.2.69l0,.09,3.37-2.45-.08-.14a.69.69,0,0,1,0-.69l.47-.81a.69.69,0,0,1,.6-.35h.93a.69.69,0,0,1,.6.35l.47.81a.69.69,0,0,1,0,.69l-.47.81a.69.69,0,0,1-.6.35h-.93a.69.69,0,0,1-.6-.35v-.07L18,15.79Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.89,15.44a.69.69,0,0,0-.6-.35H14.71a.69.69,0,0,0-.6.35l-.79,1.37a.69.69,0,0,0,0,.69l.79,1.37a.69.69,0,0,0,.6.35h1.58a.69.69,0,0,0,.6-.35l.79-1.37a.69.69,0,0,0,0-.69Z",
    transform: "translate(0 0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.83 22.06 23.3 21.26 22.83 20.45 21.9 20.45 21.43 21.26 21.9 22.06 22.83 22.06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.59,28.5h21.9a3.79,3.79,0,0,0,3.43-2.16H5.16A3.79,3.79,0,0,0,8.59,28.5Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.54.13A11.91,11.91,0,0,0,34.85,0H12A12,12,0,0,0,0,12H0V24.15a12,12,0,0,0,12,12H34.85A11.91,11.91,0,0,0,36.54,36Zm-6,29.62H8.59a5,5,0,0,1-5.05-5h.67V11A4.26,4.26,0,0,1,8.47,6.75H30.61A4.26,4.26,0,0,1,34.87,11h0V24.75h.67a5,5,0,0,1-5,5Z",
    transform: "translate(0 0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.83 13.06 23.3 12.26 22.83 11.45 21.9 11.45 21.43 12.26 21.9 13.06 22.83 13.06"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.32 18.07 36.54 0 36.54 36.15 47.32 18.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShareOn2);
export default __webpack_public_path__ + "static/media/screen-share-on2.5c48e4b9.svg";
export { ForwardRef as ReactComponent };